// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { FaEdit, FaTrash, FaPlus, FaEye } from 'react-icons/fa';
// import QuotationForm from './QuotationForm';
// import QuotationPreviewModal from './QuotationPreviewModal';
// import { useNavigate } from 'react-router-dom';
// import ReactPaginate from 'react-paginate';
// import { useAuth } from '../../context/AuthContext';
// import withPermission from '../../utils/withPermission';
// import Swal from 'sweetalert2';
// import Select from 'react-select';
// import { Button, Form, Row, Col, Modal, Offcanvas, Table, Card, Badge } from 'react-bootstrap';

// const AllQuotation = () => {
//     const [quotations, setQuotations] = useState([]);
//     const [projects, setProjects] = useState([]);
//     const [clients, setClients] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [showPreviewModal, setShowPreviewModal] = useState(false);
//     const [selectedQuotationId, setSelectedQuotationId] = useState(null);
//     const [selectedQuotationData, setSelectedQuotationData] = useState(null);
//     const [errors, setErrors] = useState({});
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageCount, setPageCount] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [products, setProducts] = useState([]);
//         const [uploading, setUploading] = useState(false);
//             const fileInputRef = useRef(null);



//     const [filters, setFilters] = useState({
//         client_id: '',
//         project_id: '',
//         status: '',
//         date_from: '',
//         date_to: '',
//         search: ''
//     });

//     const navigate = useNavigate();
//     const { user } = useAuth();
//     const [brands, setBrands] = useState([]);
//     const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
//     // Permission wrappers
//     const WithCreatePermission = withPermission(({ children }) => children, ['quotation-create']);
//     const WithEditPermission = withPermission(({ children }) => children, ['quotation-edit']);
//     const WithDeletePermission = withPermission(({ children }) => children, ['quotation-delete']);
//     const WithViewPermission = withPermission(({ children }) => children, ['quotation-view']);

//     useEffect(() => {
//         fetchQuotations(currentPage);
//         fetchClients();
//         fetchProjects();
//         fetchBrands();
//         fetchCategories();
//     }, [currentPage, filters]);
//     const fetchBrands = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             const response = await axios.get(`${backendUrl}/api/brands`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });
//             setBrands(response.data.brand);
//         } catch (error) {
//             console.error('Error fetching brands:', error);
//         }
//     };

//     const fetchCategories = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });
//             const allCategories = response.data.category;
//             const allCategoriesList = allCategories.filter(cat => !cat.parent_id);
//             const allSubcategories = allCategories.filter(cat => cat.parent_id);
//             setCategories({ allCategoriesList, allSubcategories });
//         } catch (error) {
//             console.error('Error fetching categories:', error);
//         }
//     };

//     const fetchQuotations = async (page = 1) => {
//         try {
//             setLoading(true);
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build query parameters
//             const params = new URLSearchParams({
//                 page: page,
//                 per_page: 20
//             });

//             // Add filters if they exist
//             Object.keys(filters).forEach(key => {
//                 if (filters[key]) {
//                     params.append(key, filters[key]);
//                 }
//             });

//             const url = `${backendUrl}/api/quotations?${params.toString()}`;
//             const response = await axios.get(url, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const quotationData = response.data.quotations || response.data.data || [];
//             setQuotations(quotationData);

//             const totalPages = response.data.meta?.total_pages || response.data.last_page || 1;
//             setPageCount(totalPages);
//             setCurrentPage(page);
//         } catch (error) {
//             console.error('Error fetching quotations:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to load quotations',
//                 timer: 3000,
//                 showConfirmButton: false
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchClients = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts?type=client`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setClients(response.data.Data || response.data.data || []);
//         } catch (error) {
//             console.error('Error fetching clients:', error);
//         }
//     };

//     const fetchProjects = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/projects?all=true`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setProjects(response.data.Data || response.data.data || []);
//         } catch (error) {
//             console.error('Error fetching projects:', error);
//         }
//     };

//     const addQuotation = async (newQuotation) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/quotations`, newQuotation, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const createdQuotation = response.data.quotation || response.data.data;
//             setQuotations(prev => [createdQuotation, ...prev]);
//             handleCloseModal();

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Quotation created successfully!',
//                 timer: 3000,
//                 showConfirmButton: false
//             });
//         } catch (error) {
//             console.error('Error adding quotation:', error);
//             if (error.response?.data?.errors) {
//                 setErrors(error.response.data.errors);
//             }
//         }
//     };

//     const editQuotation = async (quotationId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/quotations/${quotationId}?_method=PUT`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const updatedQuotation = response.data.quotation || response.data.data;
//             setQuotations(prev => prev.map(q => q.id === quotationId ? updatedQuotation : q));
//             handleCloseModal();

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Quotation updated successfully!',
//                 timer: 3000,
//                 showConfirmButton: false
//             });
//         } catch (error) {
//             console.error('Error updating quotation:', error);
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             }
//         }
//     };

//     const deleteQuotation = async (quotationId) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!"
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 try {
//                     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//                     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                     const origin = localStorage.getItem('user-origin');
//                     const token = userInfo?.token;

//                     await axios.delete(`${backendUrl}/api/quotations/${quotationId}`, {
//                         headers: {
//                             'Authorization': `Bearer ${token}`,
//                             'Tenant-Origin': origin,
//                         },
//                     });

//                     setQuotations(prev => prev.filter(q => q.id !== quotationId));
//                     Swal.fire("Deleted!", "The quotation has been deleted.", "success");
//                 } catch (error) {
//                     console.error('Error deleting quotation:', error);
//                     Swal.fire("Error!", "Failed to delete quotation.", "error");
//                 }
//             }
//         });
//     };
//         const handleUploadClick = () => {
//         fileInputRef.current?.click();
//     };

//     const handleFileUpload = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         try {
//             // Validate file type
//             const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
//             if (!allowedTypes.includes(file.type)) {
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'error',
//                     title: 'Please upload PDF, JPEG, PNG, or Word documents only',
//                     timer: 3000,
//                     showConfirmButton: false
//                 });
//                 return;
//             }

//             // Validate file size (5MB)
//             if (file.size > 5 * 1024 * 1024) {
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'error',
//                     title: 'File size must be less than 5MB',
//                     timer: 3000,
//                     showConfirmButton: false
//                 });
//                 return;
//             }

//             setUploading(true);

//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const formData = new FormData();
//             formData.append('quotation_file', file);
//             formData.append('is_uploaded', 'true');

//             const response = await axios.post(`${backendUrl}/api/quotations/upload`, formData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const uploadedQuotation = response.data.quotation || response.data.data;
//             setQuotations(prev => [uploadedQuotation, ...prev]);

//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'success',
//                 title: 'Quotation uploaded successfully!',
//                 timer: 3000,
//                 showConfirmButton: false
//             });

//             // Clear the file input
//             event.target.value = '';

//         } catch (error) {
//             console.error('Error uploading quotation:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to upload quotation',
//                 timer: 3000,
//                 showConfirmButton: false
//             });
//         } finally {
//             setUploading(false);
//         }
//     };

//     const handleShowModal = (quotationId = null) => {
//         if (quotationId) {
//             const quotationToEdit = quotations.find(q => q.id === quotationId);
//             setSelectedQuotationData(quotationToEdit);
//         } else {
//             setSelectedQuotationData(null);
//         }
//         setSelectedQuotationId(quotationId);
//         setShowModal(true);
//         setErrors({});
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedQuotationId(null);
//         setSelectedQuotationData(null);
//         setErrors({});
//     };

//     const handleShowPreview = (quotation) => {
//         setSelectedQuotationData(quotation);
//         setShowPreviewModal(true);
//     };

//     const handleClosePreview = () => {
//         setShowPreviewModal(false);
//     };


//     const handlePageChange = (selectedItem) => {
//         const newPage = selectedItem.selected + 1;
//         setCurrentPage(newPage);
//     };

//     const handleFilterChange = (key, value) => {
//         setFilters(prev => ({
//             ...prev,
//             [key]: value
//         }));
//         setCurrentPage(1); // Reset to first page when filters change
//     };

//     const clearFilters = () => {
//         setFilters({
//             client_id: '',
//             project_id: '',
//             status: '',
//             date_from: '',
//             date_to: '',
//             search: ''
//         });
//     };

//     const getStatusBadge = (status) => {
//         const statusConfig = {
//             open: { variant: 'primary', label: 'Open' },
//             quotation_approved: { variant: 'success', label: 'Approved' },
//             po_received: { variant: 'info', label: 'PO Received' },
//             work_completed: { variant: 'warning', label: 'Work Completed' },
//             payment_confirmed: { variant: 'success', label: 'Payment Confirmed' },
//             payment_collected: { variant: 'dark', label: 'Payment Collected' },
//             invalid: { variant: 'danger', label: 'Invalid' }
//         };

//         const config = statusConfig[status] || { variant: 'secondary', label: status };
//         return <Badge bg={config.variant}>{config.label}</Badge>;
//     };

//     const clientOptions = clients.map(client => ({
//         value: client.id,
//         label: client.name
//     }));

//     const projectOptions = projects.map(project => ({
//         value: project.id,
//         label: project.name
//     }));

//     const statusOptions = [
//         { value: 'open', label: 'Open' },
//         { value: 'quotation_approved', label: 'Approved' },
//         { value: 'po_received', label: 'PO Received' },
//         { value: 'work_completed', label: 'Work Completed' },
//         { value: 'payment_confirmed', label: 'Payment Confirmed' },
//         { value: 'payment_collected', label: 'Payment Collected' }
//     ];

//     const deploymentDescriptions = selectedQuotationData?.editable_deployment_descriptions
//         ? typeof selectedQuotationData.editable_deployment_descriptions === 'string'
//             ? JSON.parse(selectedQuotationData.editable_deployment_descriptions)
//             : selectedQuotationData.editable_deployment_descriptions
//         : {};

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Header Row */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">All Quotations</h4>
//                                 <div className="page-title-right">
//                                     <WithCreatePermission>
//                                         <Button
//                                             variant="primary"
//                                             onClick={() => handleShowModal()}
//                                             className="d-flex align-items-center"
//                                         >
//                                             <FaPlus className="me-2" />
//                                             Create Quotation
//                                         </Button>
//                                     </WithCreatePermission>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Filters Card */}
//                     <div className="row">
//                         <div className="col-12">
//                             <Card className="mb-3">
//                                 <Card.Body>
//                                     <Row className="g-3">
//                                         <Col md={3}>
//                                             <Form.Group>
//                                                 <Form.Label>Search</Form.Label>
//                                                 <Form.Control
//                                                     type="text"
//                                                     placeholder="Search by reference..."
//                                                     value={filters.search}
//                                                     onChange={(e) => handleFilterChange('search', e.target.value)}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={2}>
//                                             <Form.Group>
//                                                 <Form.Label>Client</Form.Label>
//                                                 <Select
//                                                     options={clientOptions}
//                                                     value={clientOptions.find(opt => opt.value === filters.client_id)}
//                                                     onChange={(opt) => handleFilterChange('client_id', opt?.value || '')}
//                                                     isClearable
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={2}>
//                                             <Form.Group>
//                                                 <Form.Label>Project</Form.Label>
//                                                 <Select
//                                                     options={projectOptions}
//                                                     value={projectOptions.find(opt => opt.value === filters.project_id)}
//                                                     onChange={(opt) => handleFilterChange('project_id', opt?.value || '')}
//                                                     isClearable
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={2}>
//                                             <Form.Group>
//                                                 <Form.Label>Status</Form.Label>
//                                                 <Select
//                                                     options={statusOptions}
//                                                     value={statusOptions.find(opt => opt.value === filters.status)}
//                                                     onChange={(opt) => handleFilterChange('status', opt?.value || '')}
//                                                     isClearable
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={2}>
//                                             <Form.Group>
//                                                 <Form.Label>From Date</Form.Label>
//                                                 <Form.Control
//                                                     type="date"
//                                                     value={filters.date_from}
//                                                     onChange={(e) => handleFilterChange('date_from', e.target.value)}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col md={1}>
//                                             <div className="d-flex align-items-end h-100">
//                                                 <Button variant="outline-secondary" onClick={clearFilters}>
//                                                     Clear
//                                                 </Button>
//                                             </div>
//                                         </Col>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>
//                         </div>
//                     </div>

//                     {/* Quotations Table Card */}
//                     <div className="row">
//                         <div className="col-12">
//                             <Card>
//                                 <Card.Body>
//                                     {loading ? (
//                                         <div className="text-center py-5">
//                                             <div className="spinner-border" role="status">
//                                                 <span className="visually-hidden">Loading...</span>
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <>
//                                             <div className="table-responsive">
//                                                 <Table hover className="mb-0">
//                                                     <thead className="table-sales-gradient">
//                                                         <tr>
//                                                             <th>#</th>
//                                                             <th>Reference No</th>
//                                                             <th>Client</th>
//                                                             <th>Project</th>
//                                                             <th>Date</th>
//                                                             <th>Amount</th>
//                                                             <th>Actions</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {quotations.length > 0 ? (
//                                                             quotations.map((quotation, index) => (
//                                                                 <tr key={quotation.id}>
//                                                                     <td>{(currentPage - 1) * 20 + index + 1}</td>
//                                                                     <td>
//                                                                         <button
//                                                                             className="dropdown-item"
//                                                                             onClick={() => handleShowPreview(quotation)}
//                                                                         >
//                                                                             {quotation.ref_no}
//                                                                         </button>
//                                                                     </td>
//                                                                     <td>{quotation?.project?.client?.name ?? 'N/A'}</td>
//                                                                     <td>{quotation?.project?.name ?? 'N/A'}</td>

//                                                                     <td>{quotation.date}</td>
//                                                                     <td>{quotation.amount}</td>

//                                                                     <td>
//                                                                         <div className="dropdown">
//                                                                             <i
//                                                                                 className="mdi mdi-dots-horizontal font-size-18"
//                                                                                 data-bs-toggle="dropdown"
//                                                                                 aria-expanded="false"
//                                                                                 style={{ cursor: "pointer" }}
//                                                                             ></i>
//                                                                             <ul className="dropdown-menu dropdown-menu-end font-size-14">
//                                                                                 <li>
//                                                                                     <WithViewPermission>
//                                                                                         <button
//                                                                                             className="dropdown-item"
//                                                                                             onClick={() => handleShowPreview(quotation)}
//                                                                                         >
//                                                                                             View Details
//                                                                                         </button>
//                                                                                     </WithViewPermission>
//                                                                                 </li>
//                                                                                 <li><WithEditPermission>
//                                                                                     <button
//                                                                                         className="dropdown-item"
//                                                                                         onClick={() => handleShowModal(quotation.id)}
//                                                                                     >
//                                                                                         Edit
//                                                                                     </button></WithEditPermission>
//                                                                                 </li>
//                                                                                 <li><WithDeletePermission>
//                                                                                     <button
//                                                                                         className="dropdown-item"
//                                                                                         onClick={() => deleteQuotation(quotation.id)}
//                                                                                     >
//                                                                                         Delete
//                                                                                     </button></WithDeletePermission>
//                                                                                 </li>
//                                                                                  <li>
//                                                                                         <button
//                                                                                             className="dropdown-item"
//                                                                                             onClick={handleUploadClick}
//                                                                                             disabled={uploading}
//                                                                                         >
//                                                                                             {uploading ? 'Uploading...' : 'Upload Quotation'}
//                                                                                         </button>
//                                                                                 </li>
//                                                                             </ul>
//                                                                         </div>
//                                                                     </td>
//                                                                 </tr>
//                                                             ))
//                                                         ) : (
//                                                             <tr>
//                                                                 <td colSpan="8" className="text-center py-4">
//                                                                     No quotations found
//                                                                 </td>
//                                                             </tr>
//                                                         )}
//                                                     </tbody>
//                                                 </Table>
//                                             </div>

//                                             {/* Pagination */}
//                                             {quotations.length > 0 && (
//                                                 <div className="d-flex justify-content-between align-items-center mt-3">
//                                                     <div>
//                                                         <span className="text-muted">
//                                                             Showing {(currentPage - 1) * 20 + 1} to {Math.min(currentPage * 20, quotations.length)} of entries
//                                                         </span>
//                                                     </div>
//                                                     <ReactPaginate
//                                                         previousLabel={'<'}
//                                                         nextLabel={'>'}
//                                                         breakLabel={'...'}
//                                                         pageCount={pageCount}
//                                                         marginPagesDisplayed={2}
//                                                         pageRangeDisplayed={3}
//                                                         onPageChange={handlePageChange}
//                                                         containerClassName={'pagination pagination-rounded mb-0'}
//                                                         pageClassName={'page-item'}
//                                                         pageLinkClassName={'page-link'}
//                                                         previousClassName={'page-item'}
//                                                         previousLinkClassName={'page-link'}
//                                                         nextClassName={'page-item'}
//                                                         nextLinkClassName={'page-link'}
//                                                         breakClassName={'page-item'}
//                                                         breakLinkClassName={'page-link'}
//                                                         activeClassName={'active'}
//                                                     />
//                                                 </div>
//                                             )}
//                                         </>
//                                     )}
//                                 </Card.Body>
//                             </Card>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Quotation Form Modal */}
//             <QuotationForm
//                 showModal={showModal}
//                 handleClose={handleCloseModal}
//                 quotationId={selectedQuotationId}
//                 quotationData={selectedQuotationData}
//                 addQuotation={addQuotation}
//                 editQuotation={editQuotation}
//                 projects={projects}
//                 clients={clients} // Pass clients data
//                 errors={errors}
//                 setErrors={setErrors}
//                 isAllQuotationsPage={true} // Add this flag to indicate it's from AllQuotations
//                 products={products}
//                 setProducts={setProducts}
//                 getClientCurrency={(clientId) => {
//                     const client = clients.find(c => c.id === clientId);
//                     return client?.currency || 'AED'; // Default to AED if not found
//                 }}
//             />

//             {/* Quotation Preview Modal */}
//             {/* <QuotationPreviewModal
//                 showModal={showPreviewModal}
//                 handleClose={handleClosePreview}
//                 quotationData={selectedQuotationData}
//             /> */}
// {showPreviewModal && selectedQuotationData && (
//     <QuotationPreviewModal
//         showModal={showPreviewModal}
//         handleClose={handleClosePreview}
//         quotationData={selectedQuotationData}
//         clientName={selectedQuotationData?.project?.client?.name || "Client Name"}
//         projectName={selectedQuotationData?.project?.name || "Project Name"}
//         clientCurrency={selectedQuotationData?.project?.client?.currency || "AED"}
//         brands={brands}
//         categories={categories}
//         selectedProducts={selectedQuotationData?.product_item_details || []}
//         customIntegrationDescription={selectedQuotationData?.custom_integration_description || ""}
//         customIntegrationTotal={selectedQuotationData?.custom_integration_total || 0}
//         formData={selectedQuotationData}
//         editableDeploymentDescriptions={deploymentDescriptions || ''}
//     />
// )}
//         </div>
//     );
// };

// export default AllQuotation;


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus, FaEye, FaFilePdf, FaUpload } from 'react-icons/fa';
import QuotationForm from './QuotationForm';
import QuotationPreviewModal from './QuotationPreviewModal';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { displayConvertedAmount } from '../../utils/currencyConverter';
import { Button, Form, Row, Col, Modal, Offcanvas, Table, Card, Badge } from 'react-bootstrap';

const AllQuotation = () => {
    const [quotations, setQuotations] = useState([]);
    const [projects, setProjects] = useState([]);
    const [clients, setClients] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedQuotationId, setSelectedQuotationId] = useState(null);
    const [selectedQuotationData, setSelectedQuotationData] = useState(null);
    const [selectedQuotationForUpload, setSelectedQuotationForUpload] = useState(null); // For upload
    const [errors, setErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [uploading, setUploading] = useState(false);
    
    // Upload form data
    const [uploadFile, setUploadFile] = useState(null);

    const [filters, setFilters] = useState({
        client_id: '',
        project_id: '',
        status: '',
        date_from: '',
        date_to: '',
        search: ''
    });

    const navigate = useNavigate();
    const { user } = useAuth();
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
    
    // Permission wrappers
    const WithCreatePermission = withPermission(({ children }) => children, ['quotation-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['quotation-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['quotation-delete']);
    const WithViewPermission = withPermission(({ children }) => children, ['quotation-view']);

    useEffect(() => {
        fetchQuotations(currentPage);
        fetchClients();
        fetchProjects();
        fetchBrands();
        fetchCategories();
    }, [currentPage, filters]);

    const fetchBrands = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/brands`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setBrands(response.data.brand);
        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };

    const fetchCategories = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const allCategories = response.data.category;
            const allCategoriesList = allCategories.filter(cat => !cat.parent_id);
            const allSubcategories = allCategories.filter(cat => cat.parent_id);
            setCategories({ allCategoriesList, allSubcategories });
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchQuotations = async (page = 1) => {
        try {
            setLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Build query parameters
            const params = new URLSearchParams({
                page: page,
            });

            // Add filters if they exist
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.append(key, filters[key]);
                }
            });

            const url = `${backendUrl}/api/quotations?${params.toString()}`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const quotationData = response.data.quotations || response.data.data || [];
            setQuotations(quotationData);

          const totalPages = response.data.meta?.total_pages || 1;
            setPageCount(totalPages);

            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching quotations:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to load quotations',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=client`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setClients(response.data.Data || response.data.data || []);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    const fetchProjects = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/projects?all=true`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setProjects(response.data.Data || response.data.data || []);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const addQuotation = async (newQuotation) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/quotations`, newQuotation, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const createdQuotation = response.data.quotation || response.data.data;
            setQuotations(prev => [createdQuotation, ...prev]);
            handleCloseModal();

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Quotation created successfully!',
                timer: 3000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error('Error adding quotation:', error);
            if (error.response?.data?.errors) {
                setErrors(error.response.data.errors);
            }
        }
    };

    const editQuotation = async (quotationId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/quotations/${quotationId}?_method=PUT`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const updatedQuotation = response.data.quotation || response.data.data;
            setQuotations(prev => prev.map(q => q.id === quotationId ? updatedQuotation : q));
            handleCloseModal();

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Quotation updated successfully!',
                timer: 3000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error('Error updating quotation:', error);
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            }
        }
    };

    const deleteQuotation = async (quotationId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/quotations/${quotationId}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setQuotations(prev => prev.filter(q => q.id !== quotationId));
                    Swal.fire("Deleted!", "The quotation has been deleted.", "success");
                } catch (error) {
                    console.error('Error deleting quotation:', error);
                    Swal.fire("Error!", "Failed to delete quotation.", "error");
                }
            }
        });
    };

     const handleDownloadPDF = async (quotationId, refNo) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}/download`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Quotation_${refNo}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading PDF:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to download PDF',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    const handleShowModal = (quotationId = null) => {
        if (quotationId) {
            const quotationToEdit = quotations.find(q => q.id === quotationId);
            setSelectedQuotationData(quotationToEdit);
        } else {
            setSelectedQuotationData(null);
        }
        setSelectedQuotationId(quotationId);
        setShowModal(true);
        setErrors({});
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedQuotationId(null);
        setSelectedQuotationData(null);
        setErrors({});
    };

    const handleShowPreview = (quotation) => {
        setSelectedQuotationData(quotation);
        setShowPreviewModal(true);
    };

    const handleClosePreview = () => {
        setShowPreviewModal(false);
    };


     const handlePageChange = (selectedItem) => {
        const newPage = selectedItem.selected + 1; // ReactPaginate uses 0-based index
        setCurrentPage(newPage); // Update state
        // fetchQuotations(newPage); // Fetch quotations for the new page
    };

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
        setCurrentPage(1); // Reset to first page when filters change
    };

    const clearFilters = () => {
        setFilters({
            client_id: '',
            project_id: '',
            status: '',
            date_from: '',
            date_to: '',
            search: ''
        });
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            open: { variant: 'primary', label: 'Open' },
            quotation_approved: { variant: 'success', label: 'Approved' },
            po_received: { variant: 'info', label: 'PO Received' },
            work_completed: { variant: 'warning', label: 'Work Completed' },
            payment_confirmed: { variant: 'success', label: 'Payment Confirmed' },
            payment_collected: { variant: 'dark', label: 'Payment Collected' },
            invalid: { variant: 'danger', label: 'Invalid' }
        };

        const config = statusConfig[status] || { variant: 'secondary', label: status };
        return <Badge bg={config.variant}>{config.label}</Badge>;
    };

    const clientOptions = clients.map(client => ({
        value: client.id,
        label: client.name
    }));

    const projectOptions = projects.map(project => ({
        value: project.id,
        label: project.name
    }));

    const statusOptions = [
        { value: 'open', label: 'Open' },
        { value: 'quotation_approved', label: 'Approved' },
        { value: 'po_received', label: 'PO Received' },
        { value: 'work_completed', label: 'Work Completed' },
        { value: 'payment_confirmed', label: 'Payment Confirmed' },
        { value: 'payment_collected', label: 'Payment Collected' }
    ];

    const deploymentDescriptions = selectedQuotationData?.editable_deployment_descriptions
        ? typeof selectedQuotationData.editable_deployment_descriptions === 'string'
            ? JSON.parse(selectedQuotationData.editable_deployment_descriptions)
            : selectedQuotationData.editable_deployment_descriptions
        : {};

    // Upload Quotation Function - FOR EXISTING QUOTATIONS
    const handleShowUploadModal = (quotation) => {
        setSelectedQuotationForUpload(quotation);
        setShowUploadModal(true);
        setUploadFile(null);
        setErrors({});
    };

    const handleCloseUploadModal = () => {
        setShowUploadModal(false);
        setSelectedQuotationForUpload(null);
        setUploadFile(null);
        setErrors({});
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Validate file type
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Please upload PDF, JPEG, PNG, or Word documents only',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            // Validate file size (5MB)
            if (file.size > 5 * 1024 * 1024) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'File size must be less than 5MB',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            setUploadFile(file);
        }
    };

   const uploadQuotation = async () => {
    try {
        if (!uploadFile) {
            Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'Please select a quotation file', timer: 3000, showConfirmButton: false });
            return;
        }

        if (!selectedQuotationForUpload) {
            Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'No quotation selected for upload', timer: 3000, showConfirmButton: false });
            return;
        }

        setUploading(true);

        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;

        const formData = new FormData();
        formData.append('quotation_file', uploadFile);

        const response = await axios.post(
            `${backendUrl}/api/quotations/${selectedQuotationForUpload.id}/upload`,
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    // ❌ remove 'Content-Type'
                },
            }
        );

        const updatedQuotation = response.data.quotation;

        setQuotations(prev =>
            prev.map(q => q.id === selectedQuotationForUpload.id ? updatedQuotation : q)
        );

        handleCloseUploadModal();

        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Quotation document uploaded successfully!',
            timer: 3000,
            showConfirmButton: false
        });

    } catch (error) {
        console.error('Error uploading quotation:', error);

        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: error.response?.data?.error || 'Failed to upload quotation document',
            timer: 3000,
            showConfirmButton: false
        });
    } finally {
        setUploading(false);
    }
};


    // ... keep all your existing functions (addQuotation, editQuotation, deleteQuotation, etc.) the same ...

   

    // ... keep the rest of your functions (handlePageChange, handleFilterChange, clearFilters, getStatusBadge, etc.) the same ...

    
    // Check if quotation has products (system-generated) or is empty (imported)
    const isSystemGenerated = (quotation) => {
        return quotation?.product_item_details?.length > 0 || 
               quotation?.custom_integration_description ||
               quotation?.is_uploaded === false;
    };

    const isImportedEmpty = (quotation) => {
        return (!quotation?.product_item_details || quotation.product_item_details.length === 0) &&
               !quotation?.custom_integration_description &&
               !quotation?.is_uploaded;
    };

    const hasUploadedDocument = (quotation) => {
        return quotation?.is_uploaded === true && quotation?.quotation_file;
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Header Row */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">All Quotations</h4>
                                <div className="page-title-right">
                                    <WithCreatePermission>
                                        <Button
                                            variant="primary"
                                            onClick={() => handleShowModal()}
                                            className="d-flex align-items-center"
                                        >
                                            <FaPlus className="me-2" />
                                            Create Quotation
                                        </Button>
                                    </WithCreatePermission>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Filters Card */}
                    <div className="row">
                        <div className="col-12">
                            <Card className="mb-3">
                                <Card.Body>
                                    <Row className="g-3">
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label>Search</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Search by reference..."
                                                    value={filters.search}
                                                    onChange={(e) => handleFilterChange('search', e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Client</Form.Label>
                                                <Select
                                                    options={clientOptions}
                                                    value={clientOptions.find(opt => opt.value === filters.client_id)}
                                                    onChange={(opt) => handleFilterChange('client_id', opt?.value || '')}
                                                    isClearable
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Project</Form.Label>
                                                <Select
                                                    options={projectOptions}
                                                    value={projectOptions.find(opt => opt.value === filters.project_id)}
                                                    onChange={(opt) => handleFilterChange('project_id', opt?.value || '')}
                                                    isClearable
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Select
                                                    options={statusOptions}
                                                    value={statusOptions.find(opt => opt.value === filters.status)}
                                                    onChange={(opt) => handleFilterChange('status', opt?.value || '')}
                                                    isClearable
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>From Date</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    value={filters.date_from}
                                                    onChange={(e) => handleFilterChange('date_from', e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1}>
                                            <div className="d-flex align-items-end h-100">
                                                <Button variant="outline-secondary" onClick={clearFilters}>
                                                    Clear
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>

                    {/* Quotations Table Card */}
                    <div className="row">
                        <div className="col-12">
                            <Card>
                                <Card.Body>
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="table-responsive">
                                                <Table hover className="mb-0">
                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Reference No</th>
                                                            <th>Client</th>
                                                            <th>Project</th>
                                                            <th>Date</th>
                                                            <th>Amount</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {quotations.length > 0 ? (
                                                            quotations.map((quotation, index) => (
                                                                <tr key={quotation.id}>
                                                                    <td>{(currentPage - 1) * 20 + index + 1}</td>
                                                                    <td>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleShowPreview(quotation)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {quotation.ref_no}
                                                                           
                                                                        </button>
                                                                    </td>
                                                                   
                                                                    <td>{quotation?.project?.client?.name ?? 'N/A'}</td>
                                                                    <td>{quotation?.project?.name ?? 'N/A'}</td>
                                                                    <td>{quotation.date}</td>
                                                                    <td>{displayConvertedAmount(quotation.amount, quotation?.project?.client?.currency || "AED")}</td>
                                                                    <td>
                                                                        <div className="dropdown">
                                                                            <i
                                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                style={{ cursor: "pointer" }}
                                                                            ></i>
                                                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                                <li>
                                                                                    <WithViewPermission>
                                                                                        <button
                                                                                            className="dropdown-item"
                                                                                            onClick={() => handleShowPreview(quotation)}
                                                                                        >
                                                                                            <FaEye className="me-2" />
                                                                                            View Details
                                                                                        </button>
                                                                                    </WithViewPermission>
                                                                                </li>
                                                                                
                                                                                {/* Edit - Only for system-generated quotations */}
                                                                                {isSystemGenerated(quotation) && (
                                                                                    <li>
                                                                                        <WithEditPermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => handleShowModal(quotation.id)}
                                                                                            >
                                                                                                <FaEdit className="me-2" />
                                                                                                Edit
                                                                                            </button>
                                                                                        </WithEditPermission>
                                                                                    </li>
                                                                                )}
                                                                                
                                                                                {/* Upload - Only for imported empty quotations without uploaded documents */}
                                                                                {isImportedEmpty(quotation) && !hasUploadedDocument(quotation) && (
                                                                                    <li>
                                                                                        <WithEditPermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => handleShowUploadModal(quotation)}
                                                                                            >
                                                                                                <FaUpload className="me-2" />
                                                                                                Upload Document
                                                                                            </button>
                                                                                        </WithEditPermission>
                                                                                    </li>
                                                                                )}

                                                                                <li>
                                                                                    <WithDeletePermission>
                                                                                        <button
                                                                                            className="dropdown-item text-danger"
                                                                                            onClick={() => deleteQuotation(quotation.id)}
                                                                                        >
                                                                                            <FaTrash className="me-2" />
                                                                                            Delete
                                                                                        </button>
                                                                                    </WithDeletePermission>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" className="text-center py-4">
                                                                    No quotations found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>

                                            {/* Pagination */}
                                            {quotations.length > 0 && (
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div>
                                                        <span className="text-muted">
                                                            Showing {(currentPage - 1) * 20 + 1} to {Math.min(currentPage * 20, quotations.length)} of entries
                                                        </span>
                                                    </div>
                                                 <div className="d-flex justify-content-end pagination-sm">
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageChange}
                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item previous'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item next'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                />
            </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>

            {/* Quotation Form Modal */}
            <QuotationForm
                showModal={showModal}
                handleClose={handleCloseModal}
                quotationId={selectedQuotationId}
                quotationData={selectedQuotationData}
                addQuotation={addQuotation}
                editQuotation={editQuotation}
                projects={projects}
                clients={clients}
                errors={errors}
                setErrors={setErrors}
                isAllQuotationsPage={true}
                products={products}
                setProducts={setProducts}
                getClientCurrency={(clientId) => {
                    const client = clients.find(c => c.id === clientId);
                    return client?.currency || 'AED';
                }}
            />

            {/* Upload Document Modal */}
            <Offcanvas show={showUploadModal} onHide={handleCloseUploadModal} style={{ width: '500px' }} placement='end'>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        Upload Quotation Document
                        {selectedQuotationForUpload && (
                            <div className="small text-muted mt-1">
                                For: {selectedQuotationForUpload.ref_no} - {selectedQuotationForUpload?.project?.client?.name} - {selectedQuotationForUpload?.project?.name}
                            </div>
                        )}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                   {selectedQuotationForUpload && (
                        <div className="mt-3 p-3 border rounded bg-light">
                            <h6 className="mb-2">Quotation Details:</h6>
                            <div className="row small">
                                <div className="col-md-6">
                                    <strong>Reference:</strong> {selectedQuotationForUpload.ref_no}
                                </div>
                                <div className="col-md-6">
                                    <strong>Client:</strong> {selectedQuotationForUpload?.project?.client?.name}
                                </div>
                                <div className="col-md-6">
                                    <strong>Project:</strong> {selectedQuotationForUpload?.project?.name}
                                </div>
                                <div className="col-md-6">
                                    <strong>Date:</strong> {selectedQuotationForUpload.date}
                                </div>
                            </div>
                        </div>
                    )}
                    <br/><br/>
                    <Form.Group>
                        <Form.Label>Document *</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            isInvalid={errors.quotation_file}
                        />
                       
                        <Form.Control.Feedback type="invalid">
                            {errors.quotation_file}
                        </Form.Control.Feedback>
                    </Form.Group>

                   
                </Offcanvas.Body>
                <div className="offcanvas-footer p-3 border-top d-flex justify-content-end ">
                    <Button variant="secondary" onClick={handleCloseUploadModal}>
                        Cancel
                    </Button>&nbsp;
                    <Button 
                        variant="primary" 
                        onClick={uploadQuotation}
                        disabled={uploading || !uploadFile}
                    >
                        {uploading ? 'Uploading...' : 'Upload'}
                    </Button>
                </div>
            </Offcanvas>

            {/* Quotation Preview Modal */}
            {showPreviewModal && selectedQuotationData && (
                <QuotationPreviewModal
                    showModal={showPreviewModal}
                    handleClose={handleClosePreview}
                    quotationData={selectedQuotationData}
                    clientName={selectedQuotationData?.project?.client?.name || "Client Name"}
                    projectName={selectedQuotationData?.project?.name || "Project Name"}
                    clientCurrency={selectedQuotationData?.project?.client?.currency || "AED"}
                    brands={brands}
                    categories={categories}
                    selectedProducts={selectedQuotationData?.product_item_details || []}
                    customIntegrationDescription={selectedQuotationData?.custom_integration_description || ""}
                    customIntegrationTotal={selectedQuotationData?.custom_integration_total || 0}
                    formData={selectedQuotationData}
                    editableDeploymentDescriptions={deploymentDescriptions || ''}
                    isUploaded={hasUploadedDocument(selectedQuotationData)}
                    uploadedFileUrl={selectedQuotationData?.quotation_file}
                      onDownload={() => handleDownloadPDF(
                                selectedQuotationData.id,
                                selectedQuotationData.ref_no
                            )}
                />
            )}
        </div>
    );
};

export default AllQuotation;
